module.exports = __webpack_public_path__ + "img/cabal-debito.22482b23.svg";